import React, { Component } from "react";
import styled from "styled-components";
import { Flex } from "../../components";
import vars from "../../vars";
import 'katex/dist/katex.min.css';
import Equation from '../../components/Equation2';
import { swipedetect } from '../../lib/swiper';
import Report from '../../components/Report/Report';
import { deleteQuestionBookmark} from '../../lib/api';
import Shimmer from '../../components/shimmer';
import LayoutWrapper from '../../components/LayoutWrapper';

const Image = styled(Flex)`
  height: 15rem;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const Hint = styled(Flex)`
  padding: 0.3em 0;
  direction: row;
  span{
    color: #4E54C8;
    font-size: 14px;
    // font-weight: bold;
  },
  svg {
    color: ${vars.brand_color};
    padding: 0.5em 0;
  }
`;

const GridLayout = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-gap: 2rem;
  @media (max-width: 768px) {
    grid-template-columns: auto;
  }
`;


// const LayoutWrapper = styled.div`
//   position: absolute;
//   width: 100%;
//   height: 100%;
// //   padding-top: 100px;
//   padding: 20px;
//   margin-top: 100px;
//   padding-bottom:100px;
//   overflow-y: auto;
// @media (max-width: 768px) {
//   margin: 0;
//   padding: 1em 1.5em;
//   padding-top:0;
//   padding-bottom:100px;
//   background-color: white;
// }
// `;

class Questions extends Component {
  state = {
    questions: this.props.data,
    selected_question: 0,
    offline: false,
    showShimmer: false,
  };


  // componentWillMount() {
  //   localStorage.removeItem('lastX');
  //   localStorage.removeItem('lastScrollLeftPosition');
  // }

  componentDidMount = () => {

    localStorage.removeItem('lastX');
    localStorage.removeItem('lastScrollLeftPosition');

    window.addEventListener("online", () => {
      this.setState({ offline: false });
    }, false);
    window.addEventListener("offline", () => {
      this.setState({ offline: true });
    }, false);
    var self = this;
    let questions = this.props.data;
    if (!questions || !questions.length) {
      return
    }
    var el = document.getElementById('questionArea')
    document.body.style.background = 'white';
    document.body.style.overflow = 'hidden';
    swipedetect(el, function (swipedir) {
      if (swipedir == 'left' || swipedir == 'right') {
        self.onLeftorRightSwipe(swipedir);
      }
      if (swipedir == 'top' || swipedir == 'down') {
        console.log('up or down');
      }
    });
  }

  onLeftorRightSwipe = (swipedir) => {
    let questions = this.props.data;
    let qid = this.state.selected_question;
    // let swipeDistance;
    if (swipedir === 'left' && qid == questions.length - 1) return;
    if (swipedir === 'right' && qid == 0) return;
    this.setState({ showShimmer: true })
    setTimeout(() => {
      this.setState({ showShimmer: false })
      if (swipedir === 'left') {
        this.nextQuestion('swipe')
      } else {
        this.previousQuestion('swipe')
      }
    }, 100)
  }

  nextQuestion = (swipe) =>{
    if (swipe==='swipe') {
      let qid = this.state.selected_question;
      this.setState({selected_question : qid+1, showShimmer: false})
    } else {
      this.setState({showShimmer: true})
      setTimeout(()=>{
        let qid = this.state.selected_question;
        this.setState({selected_question : qid+1, showShimmer: false})
      }, 100)
    }
  }

  previousQuestion = (swipe) =>{
    if(swipe==='swipe') {
      let qid = this.state.selected_question;
      this.setState({selected_question : qid - 1})
    } else{
      this.setState({showShimmer: true})
      setTimeout(()=>{
        let qid = this.state.selected_question;
        this.setState({selected_question : qid - 1, showShimmer: false})
      }, 100)
    }
    
  }

  checkNative = () => {
    try {
      if ((window.webkit) || window.appInterface)
        return true;
      else return false;
    } catch (error) {
      console.log(error);
    }
  }

  callbackToNative = (msg) => {
    try {
      if (window.webkit != undefined) {
        window.webkit.messageHandlers.observe.postMessage(msg);
        window.webkit.messageHandlers.appInterface.postMessage(msg)
      }
      if (window.appInterface != undefined) {
        window.appInterface.postMessage(msg)
      }
    } catch (error) {
      console.log(msg);
      console.log(error);
    }
  }


  goBack = () => {
    let native = this.checkNative()
    if(native) {
      this.callbackToNative('done')
    }
  };

  handleBookMark = () => {
    let { tid, qid, questions } = this.props;
    this.setState(prevState => {
      let question = prevState.question_answers.find(
        ({ question_id }) => question_id === questions[qid].id
      );
      question.question_option_id = null;
      question.isBookMarked = true;
      return prevState;
    });
  };

  deleteBookmark = async () => {
    console.log(this.state.selected_question)
    let id = this.props.data[this.state.selected_question].id
    let response = await deleteQuestionBookmark(id);
    if (response.status === 200) {
      this.props.data.splice(this.state.selected_question, 1)
    }
    if (this.props.data.length == this.state.selected_question){
      console.log('last question')
      console.log(this.state.selected_question-1)
      this.setState({questions: this.props.data, selected_question: this.state.selected_question -1})
      
    } else {
      this.setState({questions: this.props.data})
    }
  };

  render() {
    let questions = this.props.data;
    let qid = this.state.selected_question;
    console.log(qid)
    let {  modalOpen } = this.state;
    if (!questions || !questions.length) {
      return <div>
        <div >
          <div style={{ width: '50px',margin: '1em 1.5em 0 1.5em', cursor: 'pointer' }}>
              <img onClick={this.goBack} src="/images/back.svg"></img>

          </div>
          <div style={{width: '100%', margin: '40px'}}>
          <div>No Bookmarked questions</div>

          </div>
        </div>
        </div>
    }
    let pattern = /\$.*?\$/gm;
    let progress = ((qid + 1) / questions.length ) * 100;
    let greyWidth = 100 - progress;
    
    return (
      <div style={{backgroundColor: 'white', overflow: 'hidden'}}>
        <div style={{position: 'fixed', top: '0', left: '0', backgroundColor: 'white', width: '100%', zIndex: '1', height: '100px' }}>
            <div style={{ width: '50px',margin: '1em 1.5em 0 1.5em', cursor: 'pointer' }}>
                <img onClick={this.goBack} src="/images/back.svg"></img>
            </div>

            <Flex>
              <div style={{margin: '1em 1.5em 0 1.5em', fontSize: '16px', fontWeight: '600'}}>
                  {qid + 1} of {questions.length}
              </div>
              <div style={{margin: '1em 1.5em 0 auto ', width: '30px', marginRight: '1.5em', justifyContent: 'flex-end',display: 'flex', flexDirection: 'row'}}>
                {qid != 0 ? 
                  <img style={{marginRight: '20px'}} onClick={this.previousQuestion} src="/images/backArrow.svg"></img>
                  : null}
                {qid + 1 != questions.length ? 
                  <img onClick={this.nextQuestion} src="/images/frontArrow.svg"></img>
                  : null}
              </div>
            </Flex>
            <div style={{margin: '1em 1.5em'}}>
                <div style={{width: '100%', height: '6px', display: 'flex', flexDirection: 'row'}}>
                  <div className='gradient' style={{width: progress+ '%'}}></div>
                  <div className='greyProgress' style={{width: greyWidth + '%', backgroundColor: '#eee'}} ></div>

                </div>

            </div>
        </div>
          {/* </div>
        </div> */}
        <LayoutWrapper id='questionArea'>
          {this.state.showShimmer ? <Shimmer /> :
            <GridLayout>
              <Flex column>
                <div><Equation math_type={questions[qid].math_type} bold equation={questions[qid].name}></Equation></div>
                {questions[qid].media === 1 && (
                  <Image center>
                    <img src={questions[qid].question_img} alt="" />
                  </Image>
                )}
                <Hint alignCenter>
                    {/* <div style={{ cursor: "pointer" }} onClick={this.handleBookMark}>
                          <span>{question_answers[qid].isBookMarked ? 'Marked For Review' : 'Mark For Review'}</span>
                    </div> */}
                    <div style={{margin: 'auto', marginLeft: '0', display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        <div style={{fontSize: '12px',color: '#ccc'}}>Level - {questions[qid].blooms_level}</div>
                    </div>
                    <div style={{margin: 'auto', marginRight: '5px', display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                      <div style={{ cursor: "pointer", marginRight: '10px' }}>
                        <Report questionId={questions[qid].id} ></Report>
                      </div>
                      <div style={{ cursor: "pointer", margin: '0', padding: '0' }} onClick={this.deleteBookmark}>
                            <img style={{ color: 'white', width: '20px', height: '18px' }} src="/images/bookmarked.svg"></img>
                      </div>
                    </div>
                  </Hint>

                <div style={{display: 'flex', flexDirection: 'column', marginTop: '10px'}}>
                  {questions[qid].options.map(
                    ({ id, name, media, option_img, is_answer }, i) => (
                      <div key={i} className={ is_answer ? 'gradient2' : 'gradient1'}>
                        <div style={{width: '100%'}}>
                        <div >
                          <div style={{position: 'absolute',left: '7px',top: '10px',width: '20px',height: '20px',borderRadius: '10px',textAlign: 'center',background: '#EEEEEE',fontSize: '10px'}}>
                              <p style={{margin: '0.2em 0', color: 'black'}}>{i + 1}</p>
                          </div>
                          <div style={{ paddingLeft: '40px', paddingRight: '20px', paddingTop: '8px' }}>
                              <Equation math_type={questions[qid].math_type} is_answer = {is_answer} equation={name}></Equation>
                              {media === 1 && <img src={option_img} alt="" />}
                          </div>
                        </div>
                        </div>
                      </div>                       
                    )
                  )}
                </div>
              </Flex>
            </GridLayout>}
        </LayoutWrapper>
        <style jsx='true' scoped>{`
          .gradient1{
            background: 
              linear-gradient(#fff,#fff) padding-box, 
              linear-gradient(to right bottom, #FFFFFF 0%, #4E54C8 39.777%, #DD92D8 100%) border-box;
            color: #313149;
            padding:10px;
            border: 2px solid transparent;
            border-radius:10px;
            display:inline-block;
            margin-bottom: 10px;
            position: relative;
            text-align: center;
            height: 100%;
          }

          .gradient2{
            background: 
              linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) padding-box, 
              linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) border-box;
            color: #313149;
            padding:10px;
            border: 2px solid transparent;
            border-radius:10px;
            display:inline-block;
            margin-bottom: 10px;
            position: relative;
            text-align: center;
            height: 100%;
          }
          .gradient{
            background:linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) padding-box;
            border: 1px transparent;
            display: inline-block;
            border-top-left-radius: 8px;
            border-bottom-left-radius: 8px;


          }
          .greyProgress{
            border-top-right-radius: 8px;
            border-bottom-right-radius: 8px;
          }
        
        
        `}
        </style>
      </div>
    );
  }
}

export default Questions;
